/**
 * NOLAS 2026, application multi evenement e.labriquerie.net.
 * src/i18n/fr.cvVisionneuse.ts
 *
 * Messages de la visionneuse de CV de l'espace entreprise
 * (components/cv/CvVisionneuse.tsx), ouverte depuis la page « CV reçus ».
 * Fusionné dans fr.ts.
 *
 * Plateforme multi-événements : aucun nom d'événement, de lieu, ni de type
 * d'événement écrit en dur. Ces messages n'en ont pas besoin : ils parlent
 * du CV, du fichier et de l'appareil, jamais de l'événement.
 *
 * Mikael - chef de projet - 2026-10-04
 */
export const messagesCvVisionneuseFr: Record<string, string> = {
  // ── Ouverture depuis la liste ──────────────────────────────────────────
  'cvVisionneuse.voir': 'Voir le CV',
  'cvVisionneuse.voir.aria': 'Voir le CV de {nom}',

  // ── Barre de la visionneuse ────────────────────────────────────────────
  'cvVisionneuse.titre': 'CV de {nom}',
  'cvVisionneuse.fermer': 'Fermer',
  'cvVisionneuse.fermer.aria': 'Fermer le CV de {nom}',
  'cvVisionneuse.telecharger': 'Télécharger l’original',
  'cvVisionneuse.ouvrir': 'Ouvrir dans un nouvel onglet',

  // ── PDF ────────────────────────────────────────────────────────────────
  'cvVisionneuse.pdf.cadre': 'CV de {nom}, document PDF',
  'cvVisionneuse.pdf.mobile':
    'Sur cet appareil, le PDF s’affiche en plein écran dans un nouvel onglet.',
  'cvVisionneuse.pdf.ouvrir': 'Ouvrir le PDF',
  'cvVisionneuse.pdf.apercu': 'Aperçu du texte',

  // ── Texte (Word, ODT, et PDF sur téléphone) ────────────────────────────
  'cvVisionneuse.texte.mention':
    'Aperçu du texte, la mise en page d’origine est dans le fichier.',
  'cvVisionneuse.texte.partiel':
    'Lecture partielle : certains passages peuvent manquer, le fichier d’origine fait foi.',
  'cvVisionneuse.texte.tronque':
    'Ce CV est très long : la fin est dans le fichier d’origine.',
  'cvVisionneuse.texte.chargement': 'Lecture du CV…',
  'cvVisionneuse.texte.indisponible':
    'Le texte de ce CV n’est pas encore disponible. Téléchargez l’original pour le lire.',
  'cvVisionneuse.texte.vide':
    'Aucun texte lisible dans ce CV (document scanné ou mis en image). Téléchargez l’original pour le voir.',
  'cvVisionneuse.texte.erreur':
    'Impossible de lire ce CV pour le moment. Téléchargez l’original.',
  'cvVisionneuse.texte.refuse':
    'Ce CV ne vous est pas accessible, ou n’est plus partagé.',

  // ── Image ──────────────────────────────────────────────────────────────
  'cvVisionneuse.image.alt': 'CV de {nom}',
  'cvVisionneuse.image.plus': 'Agrandir',
  'cvVisionneuse.image.moins': 'Réduire',
  'cvVisionneuse.image.ajuster': 'Ajuster à l’écran',
  'cvVisionneuse.image.niveau': 'Zoom {pct} %',
  'cvVisionneuse.image.aide':
    'Pincez avec deux doigts ou utilisez la molette pour zoomer, faites glisser pour vous déplacer.',
  'cvVisionneuse.image.erreur':
    'L’image ne s’affiche pas. Téléchargez l’original.',

  // ── Autre format ───────────────────────────────────────────────────────
  'cvVisionneuse.autre':
    'Ce format ne s’affiche pas dans l’application. Téléchargez l’original.',
};
